import Alpine from 'alpinejs';
import { attachInitToStoreInstance } from '@/utils/attach_init_to_store';
import { appStore } from '../app';
import { EntryFlowStore } from './entry_flow';

const cookieDomain = appStore.getGlobalData().cookieDomain;
const currentPolicyVersion = appStore.getGlobalData()?.cookieConsentService?.currentPolicyVersion;
const entryFlowStoreInstance = new EntryFlowStore(cookieDomain, currentPolicyVersion);
attachInitToStoreInstance(entryFlowStoreInstance, EntryFlowStore);

Alpine.store('entryFlowStore', entryFlowStoreInstance);

export const entryFlowStore = Alpine.store('entryFlowStore') as EntryFlowStore;
